import BaseAPI from '@/services/api/internal/tools/baseAPI';
import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import { formatDateToInputDate } from '@/business/utils/dates';
import makeListRequest from '@/store/modules/dashboardPem/makeListRequest';

const dateFilter = new Date();
dateFilter.setDate(new Date().getDate() - 14);

const attributesObjRef = {};
const attributesObj = {
  ended_limit: {
    type: '$endedLimit',
    values: [formatDateToInputDate(dateFilter)],
  },
  entity_nav_full_id: {
    type: '$instr',
    values: [],
  },
  action_status_id: {
    type: '$instr',
    values: [],
  },
  staffs_in_charge_id: {
    type: '$idslist',
    values: [],
  },
  action_plan_status: {
    type: '$idslist',
    values: [],
  },
  list_params: {
    type: '$parameters',
    values: [
      {
        origin: 'ended_limit',
        transformed: 'ended_limit',
      },
      { origin: 'staffs_in_charge_id', transformed: 'person_in_charge_ids' },
      { origin: 'action_plan_status', transformed: 'actionplan_status_ids' },
    ],
  },
};

export default (store) => {
  store.registerModule(
    ['dashboardPem', 'actionGain'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actions/gains`,
        }),
        urlParamsItems: { limit: 5000 },
      }),
      attributesObj,
      attributesObjRef,
      pageSizeIndex: 4,
      makeQueryParams: makeListRequest,
    })
  );
};
